// Sugalarm — Cycle 362: labelling a fired reminder OCCURRENCE.
//
// Pure + unit-tested. The rule this enforces: a reminder surface names the
// time the reminder was FOR, never the time it happens to be rendered.
//
// Why that matters. Through cycle 361 <ReminderOverlay> displayed a live
// ticking `new Date()` clock, so the 3:13 PM resurface of the member's 10:00 AM
// Lantus reminder read "At 3:13 PM" above "Its 10am. Time to Give the member his
// Lantiss" — the surface actively asserted it was firing now, which is a
// large part of why it read as a random pop-up rather than "the 10 AM one
// nobody closed". With a durable occurrence we always have the authored
// wall clock, so there is no longer any reason to guess.
//
// We render the occurrence's own `time_of_day` (the wall clock as authored,
// in the reminder's own IANA zone) rather than converting `scheduled_for`
// into the viewing device's zone: "10:00 AM" is what the household set and
// what the message itself says. Converting would make a phone travelling
// through a timezone disagree with both.

/** Format a reminder's authored "HH:MM" 24-hour wall clock for display.
 *
 * `h24` follows the user's existing `display_24h` setting. Returns the input
 * unchanged if it is not a well-formed "HH:MM" — a label must degrade to
 * something honest rather than throw on a surface that may be showing a
 * missed medication. */
export function formatReminderTime(timeOfDay: string, h24: boolean): string {
  const m = /^(\d{1,2}):(\d{2})$/.exec(timeOfDay.trim());
  if (!m) return timeOfDay;
  const hh = Number(m[1]);
  const mm = Number(m[2]);
  if (!Number.isInteger(hh) || hh > 23 || !Number.isInteger(mm) || mm > 59) {
    return timeOfDay;
  }
  const mmStr = mm < 10 ? `0${mm}` : String(mm);
  if (h24) {
    const hhStr = hh < 10 ? `0${hh}` : String(hh);
    return `${hhStr}:${mmStr}`;
  }
  const ampm = hh >= 12 ? "PM" : "AM";
  const h12 = hh % 12 === 0 ? 12 : hh % 12;
  return `${h12}:${mmStr} ${ampm}`;
}
